export default __webpack_public_path__ + "static/media/group2.0e037df4.jpg";